import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { getFullFieldName } from '~/core/application/workflow/utils/getFullFieldName';
import { EMPTY_ARR } from '~/core/shared/constants';
import { useRootDocument } from '~/core/shared/hooks';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import { WorkflowDataResolverDependencies } from '~/core/shared/types';
import { BlockRendererProps } from '../../types/BlockRendererProps';

export const useBlockRenderer = (
  propsWorkflowDataResolverDependencies: BlockRendererProps['workflowDataResolverDependencies'],
  namePrefixes: BlockRendererProps['namePrefixes'] = EMPTY_ARR,
) => {
  const rootDocument = useRootDocument();
  const { getValues } = useFormContext();

  const getFormValue = useEventHandler((key: string) =>
    getValues(getFullFieldName(key, namePrefixes)),
  );

  const workflowDataResolverDependencies: WorkflowDataResolverDependencies =
    useMemo(
      () => ({
        getFormValue,
        rootDocument,
        ...propsWorkflowDataResolverDependencies,
      }),
      [getFormValue, rootDocument, propsWorkflowDataResolverDependencies],
    );

  return {
    workflowDataResolverDependencies,
  };
};
